import type { HomePage } from '@/data/types';
import homepageData from '@/data/homepage.json';

export function useHomepageData() {
  const pageData = homepageData as HomePage;
  return { pageData, loading: false, error: null };
}